import gql from 'graphql-tag';

export default gql`
query NearestZip($latitude: BigFloat!, $longitude: BigFloat!) {
    nearestZip(latitude: $latitude, longitude: $longitude)
}
`;